<template>
  <a-col :sm="col" :md="col" :xl="col">
    <a-card
      style="width: 100%"
      class="flex flex-direction justify-center cardListData"
      v-if="type == 'Statistic' || type == 'Echarts'"
      :class="[
        textAlign == 'center'
          ? 'align-center'
          : textAlign == 'left'
          ? 'align-start'
          : 'align-end',
      ]"
    >
      <template v-if="type == 'Statistic'">
        <template v-if="isTime">
          <p
            :class="[
              fontTextAlign == 'center'
                ? 'text-center'
                : fontTextAlign == 'left'
                ? 'text-start'
                : 'text-end',
            ]"
            v-if="currentDateNumer == 1"
          >
            今日 | {{ title }}
          </p>
          <p
            :class="[
              fontTextAlign == 'center'
                ? 'text-center'
                : fontTextAlign == 'left'
                ? 'text-start'
                : 'text-end',
            ]"
            v-if="currentDateNumer == 2"
          >
            昨日 | {{ title }}
          </p>
          <p
            :class="[
              fontTextAlign == 'center'
                ? 'text-center'
                : fontTextAlign == 'left'
                ? 'text-start'
                : 'text-end',
            ]"
            v-if="currentDateNumer == 3"
          >
            近七日 | {{ title }}
          </p>
        </template>
        <p
          :class="[
            fontTextAlign == 'center'
              ? 'text-center'
              : fontTextAlign == 'left'
              ? 'text-start'
              : 'text-end',
          ]"
          v-else
        >
          {{ title }}
        </p>
        <p v-if="isTime">{{ filterDate_filter(currentDateNumer) }}</p>
        <p
          :class="[
            fontTextAlign == 'center'
              ? 'text-center'
              : fontTextAlign == 'left'
              ? 'text-start'
              : 'text-end',
          ]"
        >
          {{ total }}
        </p>
        <template v-if="isSwitch">
          <a-radio-group
            :value="switchValue"
            @update:value="(val) => $emit('update:switchValue', val)"
            @change="(e) => changeRadioGroup(e.target.value)"
            button-style="solid"
          >
            <a-radio-button
              v-for="(item, index) in switchList"
              :value="item.value"
            >
              {{ item.name }}
            </a-radio-button>
          </a-radio-group>
        </template>
      </template>
      <div :id="id" :style="style" v-if="type == 'Echarts'"></div>
    </a-card>
    <!--    <div v-if="type=='rank'" style="width: 100%;">
                <RankComponents  :rank-list="carSourceList" count-field="val" label-field="label"></RankComponents>
              </div>-->
  </a-col>
</template>

<script>
import { $on, $off, $once, $emit } from '../../utils/gogocodeTransfer'

import * as echarts from 'echarts'
export default {
  name: 'Statistics',
  components: {},
  props: {
    col: {
      type: Number,
      default: 12,
    },
    type: {
      type: String,
      default: 'Statistic',
    },

    textAlign: {
      type: String,
      default: 'center',
    },
    fontTextAlign: {
      type: String,
      default: 'center',
    },
    isSwitch: {
      type: Boolean,
      default: false,
    },
    switchValue: {
      type: String,
      default: 'a',
    },
    switchList: {
      type: Array,
      default: () => {
        return [
          {
            name: '今日',
            value: 'a',
          },
          {
            name: '昨日',
            value: 'b',
          },
          {
            name: '近七日',
            value: 'c',
          },
        ]
      },
    },
    title: {
      type: String,
      default: '',
    },
    isTime: {
      type: Boolean,
      default: false,
    },
    total: {
      type: Number,
    },
    id: {
      type: String,
    },
    isCustomizedEcharts: {
      type: Boolean,
      default: false,
    },
    echartsType: {
      type: String,
      default: 'line',
    },
    echartsData: {
      type: Array,
      default: () => {
        return []
      },
    },
    height: {
      type: String,
      default: '500px',
    },
    isWidth: {
      type: Boolean,
      defualt: false,
    },
    width: {
      type: String,
      default: '100%',
    },
    option: {
      type: Object,
    },
    carSourceList: {
      type: Array,
      default: () => {
        return [
          {
            label: '电视',
            val: 1000,
            percent: 100,
          },
          {
            label: '电视剧',
            val: 10,
            percent: 10,
          },
        ]
      },
    },
  },
  data() {
    return {
      currentDateNumer: 1,
      chart: null,
      widthDom: 0,
    }
  },
  computed: {
    style() {
      return {
        width: this.widthDom,
        height: this.height,
      }
    },
  },
  watch: {
    option: {
      handler(newVal, oldVal) {
        console.log('this.type')
        console.log(this.type)
        if (this.chart) {
          this.chart.setOption(newVal)
        } else {
          setTimeout(() => {
            this.init()
          }, 700)
        }
      },
      deep: true,
    },
  },
  mounted() {
    /*console.log('window.innerWidth');
  console.log(window.innerWidth);*/

    if (this.isWidth) {
      this.widthDom = this.width
    } else {
      this.widthDom = window.innerWidth - 350 + 'px'
    }
    setTimeout(() => {
      this.init()
      console.log('卡片宽度')
    }, 700)
  },
  emits: ['update:switchValue', 'change'],
  methods: {
    filterDate_filter(value) {
      var today = new Date()
      if (value === 1) {
        var year = today.getFullYear() //获取年份
        var month = today.getMonth() + 1 //获取月份
        var day = today.getDate() //获取日期
        return (
          year + '-' + month + '-' + day + '~' + year + '-' + month + '-' + day
        )
      } else if (value === 2) {
        let yesterday = new Date(today.getTime() - 24 * 60 * 60 * 1000)
        return (
          yesterday.getFullYear() +
          '-' +
          (yesterday.getMonth() + 1) +
          '-' +
          yesterday.getDate() +
          '~' +
          yesterday.getFullYear() +
          '-' +
          (yesterday.getMonth() + 1) +
          '-' +
          yesterday.getDate()
        )
      } else if (value === 3) {
        let yesterday = new Date(today.getTime() - 144 * 60 * 60 * 1000)
        let yesterdays = new Date(today.getTime())
        return (
          yesterday.getFullYear() +
          '-' +
          (yesterday.getMonth() + 1) +
          '-' +
          yesterday.getDate() +
          '~' +
          yesterdays.getFullYear() +
          '-' +
          (yesterdays.getMonth() + 1) +
          '-' +
          yesterdays.getDate()
        )
      }
    },
    changeRadioGroup(e) {
      console.log(e)
      $emit(this, 'update:switchValue', e)
      $emit(this, 'change', e)
    },
    init() {
      if (this.type == 'Echarts') {
        this.chart = echarts.init(document.getElementById(this.id))
        console.log('this.isCustomizedEcharts')
        console.log(this.isCustomizedEcharts)
        if (this.isCustomizedEcharts) {
          //是定制使用option
          this.chart.setOption(this.option)
        } else {
          console.log('进来了')
          //不定制
          /*line-折线图
  bar-柱状图
  pie-饼图
  pieCircle-饼状图圆环图 我自己新增的属性*/
          if (this.echartsType == 'line') {
            //折线图
            let option = {
              title: {
                text: this.title,
                left: this.fontTextAlign,
              },
              xAxis: {
                type: 'category',
                data: this.echartsData.map((i) => i.name),
              },
              yAxis: {
                type: 'value',
              },
              series: [
                {
                  data: this.echartsData.map((i) => i.value),
                  type: 'line',
                },
              ],
            }
            this.chart.setOption(option)
          } else if (this.echartsType == 'bar') {
            /*bar-柱状图*/
            let option = {
              title: {
                text: this.title,
                left: this.fontTextAlign,
              },
              xAxis: {
                type: 'category',
                data: this.echartsData.map((i) => i.name),
              },
              yAxis: {
                type: 'value',
              },
              series: [
                {
                  data: this.echartsData.map((i) => i.value),
                  type: 'bar',
                },
              ],
            }
            this.chart.setOption(option)
          } else if (this.echartsType == 'pie') {
            /*bar-柱状图*/
            let option = {
              title: {
                text: this.title,
                left: this.fontTextAlign,
              },
              tooltip: {
                trigger: 'item',
              },
              legend: {
                top: '5%',
                left: 'center',
              },
              series: [
                {
                  name: '数据值',
                  type: 'pie',
                  radius: ['40%', '70%'],
                  avoidLabelOverlap: false,
                  padAngle: 5,
                  itemStyle: {
                    borderRadius: 10,
                  },

                  label: {
                    formatter: '{b} {c} ({d}%)',
                  },
                  emphasis: {
                    label: {
                      show: false,
                      fontSize: 40,
                      fontWeight: 'bold',
                    },
                  },
                  labelLine: {
                    show: false,
                  },
                  data: this.echartsData,
                },
              ],
            }
            this.chart.setOption(option)
          }
        }
        window.addEventListener('resize', this.chart.resize)
      }
    },
  },
}
</script>
